import { render, staticRenderFns } from "./AccountLinkingForm.vue?vue&type=template&id=7073c82d"
import script from "./AccountLinkingForm.vue?vue&type=script&lang=js"
export * from "./AccountLinkingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports